/**
 * Compute display initials for an avatar chip from a full name.
 *
 * <p>Picks the first letter of the first and last name parts. Single-word
 * names return a single initial. Empty / undefined input returns {@code "?"}.
 *
 * <p>Vietnamese family-first names land sensibly here — for
 * "Nguyễn Mai Anh" we pick "N" from the family name and "A" from the
 * personal name, giving "NA".
 *
 * @example
 *   avatarInitials("Mai Anh")          // "MA"
 *   avatarInitials("Nguyễn Mai Anh")   // "NA"
 *   avatarInitials("Demo")             // "D"
 *   avatarInitials(undefined)          // "?"
 */
export function avatarInitials(name: string | undefined): string {
  const trimmed = (name ?? "").trim();
  if (trimmed.length === 0) return "?";
  const parts = trimmed.split(/\s+/);
  const first = parts[0]!.charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1]!.charAt(0) : "";
  return (first + last).toUpperCase();
}
